<!-- 在线输入法模块封装 --古壮字 -->
<!-- 参数 top、left：定位值。可传px，rem -->
<!-- action：后台api -->
<!-- handShow：是否显示 -->
<!-- index 存储 -->
<!--  -->
<template>
  <div :style="{
      top:top,left:left
    }" class="input-ancient" ref="ancient" v-if="ancientValue" v-show="handShow">
    <div style="margin:0 16px;padding-bottom:8px;color: #b1222b;border-bottom: 1px solid #ccc;">{{ ancientValue }}</div>
    <el-collapse-transition>
      <div v-show="ancientData.length!=0">
        <div :class="is_active==index?'is-active':''" :key="index" @click="ancientClose(item,index)" class="index-search-items" v-for="(item, index) in ancientData">
          {{ item.wordCode }} {{ item.strokeCode }}
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
  export default {
    name: 'OnlineIndex',
    props: {
      ancientValue: {
        type: String,
        required: true
      },
      actions: {
        type: String,
        required: true
      },
      top: {
        type: String || Number,
        required: true,
      },
      left: {
        type: String || Number,
        required: true,
      }
    },
    data() {
      return {
        currpage: 1,
        ancientData: [],
        is_active: -1,
        handShow: false
      };
    },

    mounted() {
      this.poInit()
    },

    methods: {
      // 初始化弹窗位置
      poInit() {
        // console.log(this.$refs.ancient);
      },
      openPopup() {
        // 打开弹窗
        this.handShow = true
      },
      closePopup() {
        this.handShow = false
      },
      // 获取数据
      async inputChange() {
        let data = await this.getlistWordView();
        this.ancientData = data
        if (this.ancientData.length != 0) {
          this.openPopup()
        }
      },
      // 将当前选择古壮字通知给父元素
      ancientClose(item) {
        this.$parent.childrenEvent(item)
        this.$nextTick(() => {
          this.is_active = -1
          this.ancientData = []
          this.closePopup()
        });
      },
      enterActive() {
        if (this.ancientData.length == 0) return
        if (this.is_active == -1) {
          this.is_active = 0
        }
        this.$parent.childrenEvent(this.ancientData[this.is_active])
        this.$nextTick(() => {
          this.is_active = -1
          this.ancientData = []
          this.closePopup()
        });
      },
      // 获取 古壮字数据 回调
      getlistWordView() {
        return new Promise((provide, reject) => {
          if (this.ancientValue == '') {
            this.ancientData = []
            return
          }
          this.getWorld({
            strokeCode: this.ancientValue,
            limit: 5,
            page: this.currpage
          }).then(res => {
            if (res.data.code != 200) {
              this.$message({
                message: res.data.message,
                type: "error",
              });
              this.is_active = -1
              this.ancientData = []
            } else {
              if (res.data.data) {
                provide(res.data.data.list)
              } else {
                this.is_active = -1
                this.ancientData = []
              }
            }
          })
        })
      },
      async nextWorld(item) {
        if (item == 'next') {
          if (this.is_active == this.ancientData.length - 1) {
            // 翻页
            this.currpage++
            this.is_active = 0
            this.inputChange()
          } else {
            this.is_active++
          }
        } else if (item == 'prev') {
          if (this.is_active == 0) {
            if (this.currpage == 1) return
            this.currpage--
            this.inputChange()
            this.is_active = 4
          } else {
            this.is_active--
          }
        }
      },
      // 古壮字请求
      getWorld(row) {
        return this.$axios({
          method: 'get',
          url: this.actions,
          params: row,
        })
      }
    },
    watch: {
      ancientValue: {
        handler: function (news, old) {
          this.inputChange()
        },
        deep: true
      }
    }
  };
</script>
<style lang="less" scoped>
  .input-ancient {
    position: absolute;
    min-width: 146px;
    // height: 220px;
    background-color: #fff;
    z-index: 999;
    overflow: hidden;
    border: 1px solid #E4E7ED;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    box-sizing: border-box;
    margin: 5px 0;
    padding: 10px 0;

    /deep/ .el-input {
      width: auto;

      .el-input__inner {
        width: auto;
        padding: 0;
        margin: 0 8px;
        font-size: 14px;
        border: none;
      }
    }

    .index-search-items {
      font-size: 18px;
      padding: 0 16px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #606266;
      height: 34px;
      line-height: 34px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover, &.is-active {
        color: #b1222b;
        background-color: #F5F7FA;
      }
    }
  }
</style>
